import { getBrowserInfo } from '../adapters'
import PsmMetadata from '../common/psm-metadata'
import PsmBridge from '../common/psm-bridge'
import { DeviceMetadataWebType } from '../common/interfaces'

class PsmDeviceMetadataWeb extends PsmMetadata<DeviceMetadataWebType> {

  constructor(playerDependencies: any) {
    super(playerDependencies)
    super.setRootLevelProperties(this.setIdProperties.bind(this))
    super.setRootLevelProperties(this.setDeviceProperties.bind(this))
    super.setRootLevelProperties(this.setNavigationProperties.bind(this))
    this.playerVersion = window.TOP?.Player?.Version?.libVersion
  }

  setIdProperties() {
    const idProps = PsmBridge.psm.getIds()
    this.deviceSpecificMetadata = {
      ...this.deviceSpecificMetadata,
      cdpid: idProps?.cdpid
    };
    return this.deviceSpecificMetadata
  }

  setDeviceProperties() {
    const deviceProps = PsmBridge.psm.getDeviceProperties()
    const uaSource = getBrowserInfo()
    this.deviceSpecificMetadata = {
      ...this.deviceSpecificMetadata,
      browserName: uaSource?.browserName || null,
      browserVersion: uaSource?.browserMajorVersion || null,
      userAgent: deviceProps?.userAgent || null,
    }
    return this.deviceSpecificMetadata
  }

  setNavigationProperties() {
    const navigationProps = PsmBridge.psm.getNavigationProperties()
    this.deviceSpecificMetadata = {
      ...this.deviceSpecificMetadata,
      referrer: navigationProps?.referrer || null,
      rootDomain: navigationProps?.rootDomain || null,
    }
    return this.deviceSpecificMetadata
  }
}

export default PsmDeviceMetadataWeb
